var utils = require('lib/utils');

var Poll = Chaplin.Model.extend({
  fileName: function() { return 'polls/' + this.get('slug') + '.json'; },

  url: function() {
    return EF.ContentProvider.PollService.getUrl(this);
  },

  parse: function(response, options) {
    if(EF.options.local && response && response.data) {
      let pollData = utils.sanifyJsonApiObject(response.data, response.included);
      pollData.sections = _.orderBy(pollData.sections, 'position');
      pollData.sections.forEach((section) => {
        section.questions = _.orderBy(section.questions, 'position');
        section.questions.forEach((question) => {
          question.answers = _.orderBy(question.answers, 'position');
        });
      });
      //SDK polls expect only one section/question for now
      let sectionIndex = this.get('sectionIndex') || 0;
      let questionIndex = this.get('questionIndex') || 0;
      let question = pollData.sections[sectionIndex].questions[questionIndex];
      return question;
    } else {
      return EF.ContentProvider.PollService.parse(this, response);
    }
  },

  save: function(attrs, options) {
    return EF.ContentProvider.PollService.save(this, options);
  },

  initialize: function(attrs, options) {
    this.set('poll_key', attrs.slug);
    this.set('course_key', 'ef_test');
  }

});
_.extend(EF.Models, {
  Poll: Poll
});
